import { EuiFlexGroup, EuiFlexItem, EuiPanel, EuiSpacer, EuiText } from "@elastic/eui";
import moment from "moment-timezone";
import { Profile as ProfileType } from "../profileTypes";
import { useSingleProfileStyles } from "../profileStyles";
import Badge from "components/Badge/Badge";

interface Props {
  profile: ProfileType;
  showAsLabeledRow?: boolean;
}

const Profile = ({ profile, showAsLabeledRow = true }: Props) => {
  const classes = useSingleProfileStyles();

  const formatTime = (startTime: string, endTime: string, days: string[]) => {
    const dayLabel = days.length === 7 ? "Daily" : days.length === 5 ? "Weekdays" : "Weekends";
    const formattedStart = moment(startTime, "HH:mm:ss").format("h:mm A");
    const formattedEnd = moment(endTime, "HH:mm:ss").format("h:mm A");

    return `${dayLabel} between ${formattedStart} and ${formattedEnd}`;
  };

  return (
    <EuiPanel
      hasShadow={false}
      style={{ backgroundColor: "var(--card-background3)", borderRadius: "6px" }}>
      <EuiFlexGroup>
        <EuiFlexItem grow={3}>
          <EuiFlexGroup direction="column">
            <EuiFlexItem style={{ flexDirection: "row" }} grow={false}>
              <EuiText size="s">
                <span className={classes.title}>Profile Name:</span>
                <span>{profile?.name ?? "n/a"}</span>
              </EuiText>
            </EuiFlexItem>
            <EuiFlexItem style={{ flexDirection: "row" }} grow={false}>
              <EuiText size="s">
                <span className={classes.title}>Description:</span>
              </EuiText>
              <EuiText size="s">
                <span>{profile?.description ?? "n/a"}</span>
              </EuiText>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
        <EuiFlexItem grow={2} className={classes.colRight}>
          <EuiFlexGroup direction="column">
            <EuiFlexItem style={{ flexDirection: "row" }} grow={false}>
              <EuiText size="s">
                <span className={classes.title}>Profile Applied to All Clients:</span>
                <span>
                  <Badge text={profile?.isSyncedToClients ? "Yes" : "No"} />
                </span>
              </EuiText>
            </EuiFlexItem>
            <EuiFlexItem style={{ flexDirection: "row" }} grow={false}>
              <EuiText size="s">
                <span className={classes.title}>Active Time Zone:</span>
                <span>{profile?.timeZone ?? "n/a"}</span>
              </EuiText>
            </EuiFlexItem>
            <EuiFlexItem>
              <EuiFlexGroup gutterSize="xs">
                <EuiFlexItem style={{ flexDirection: "row" }} grow={false}>
                  <EuiText size="s">
                    <span className={classes.title}>Active Time Frame:</span>
                  </EuiText>
                </EuiFlexItem>
                <EuiFlexItem>
                  <EuiText size="s">
                    {profile?.activityWindows?.map((window) => (
                      <span key={window.id}>
                        {formatTime(window.startTime, window.endTime, window.daysOfWeek)}
                        <EuiSpacer size="xs" />
                      </span>
                    ))}
                  </EuiText>
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiPanel>
  );
};

export default Profile;
